import { SyntheticEvent, useState } from 'react';

type UseViewModelProps = {
  value: string;
  onChange: (value: string) => void;
  statusList: string[];
};

type UseViewModelReturn = {
  anchorEl: HTMLButtonElement;
  status: string;
  handleChange: (item: string) => void;
  handleClick: (event: SyntheticEvent<HTMLButtonElement>) => void;
  handleClose: () => void;
};

const useViewModel = ({
  value,
  onChange,
  statusList,
}: UseViewModelProps): UseViewModelReturn => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement>(null);
  const [status, setStatus] = useState(value === '' ? statusList[0] : value);

  const handleChange = (item): void => {
    const newValue =
      item === statusList[0]
        ? ''
        : item.charAt(0).toUpperCase() + item.slice(1);
    setStatus(item);
    onChange(newValue);
    setAnchorEl(null);
  };

  const handleClick = (event: SyntheticEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (): void => {
    setAnchorEl(null);
  };

  return {
    anchorEl,
    status,
    handleChange,
    handleClick,
    handleClose,
  };
};

export default useViewModel;
